/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Aromas_FoundInputs */

const en_no_aromas_found = /** @type {(inputs: No_Aromas_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No aromas found.`)
};

const es_no_aromas_found = /** @type {(inputs: No_Aromas_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron aromas.`)
};

/**
* | output |
* | --- |
* | "No aromas found." |
*
* @param {No_Aromas_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const no_aromas_found = /** @type {((inputs?: No_Aromas_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Aromas_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_aromas_found(inputs)
	return es_no_aromas_found(inputs)
});